import styled from 'styled-components';

export const Form = styled.form`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 24px;
  align-items: start;
  min-height: 120px;
`;

export const SubmitWrapper = styled.div`
  height: 100%;
  display: grid;
  justify-items: end;
  grid-column: span 3;
`;
